import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=e1b5f4e2&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=js&"
export * from "./inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b5f4e2",
  null
  
)

export default component.exports